import customHeaders, { getSpace } from '../../common/headers';
import { Comment } from '../Comment/Comment';
import { useState, useEffect, useRef } from 'react';
import { RavshanHttps } from '../../fetchUrls';
import { ExecutorPlaceholder } from '../OptionsExecutor/OptionsExecutor';
import useGeneralStore from '../../store/general';
import { FileItemComponent } from '../FileItemComponent/FileItemComponent';
import { ButtonActionDrop } from '../Buttons/ButtonActionDrop/ButtonActionDrop';
import answer from './img/answer.png'
import star_icon from './img/star_icon.svg'
import pin_icon from './img/pin.svg'
import "./CommentItem.scss"
import { InView } from 'react-intersection-observer';
import { TextPage } from '../TextPage/TextPage';
import check from './img/check.svg'
import double_check from './img/check-double.svg'

const parse = require('html-react-parser')
const email = localStorage.getItem('email')
const client_id = localStorage.getItem('client_id')


const CommentItem = ({ ...props }) => {
    const selectedSpace = useGeneralStore(state => state.selectedSpace)
    const headers = { ...customHeaders, ...getSpace(selectedSpace) }

    // Данные сообщения
    const {
        created_at,
        text,
        author,
        files,
        message_id,
        is_read,
        is_seen,
        parent_message,
        isAuthor,
        is_favourite,
        is_pinned,
        author_pinned
    } = props?.messageData

    // Cтейты

    const { id,
        event_id,
        date,
        fetchComments,
        disabled,
        setCurrentMessageAnswer,
        reply_to,
        setSaveFile,
        fetchAddFiles,
        fetchGetFiles,
        fetchDeleteFiles,
        type,
        comment_id,
        update,
        fetchPinComment,
        hideTools,
        hideToolsPanel,
        is_viewed,
        setCommentPage,
        updateComments,
        fetchChangeStatus,
        fetchFavorite,
        fetchDeleteFavorite,
        fetchDelete = false,
        fetchChange = false,
        messageData,
        early_message_id
    } = props

    const { name, login, color } = author

    const curr_files = files?.map((el) => {
        return {
            created_at: el?.created_at,
            file_size_kb: el?.file_size_kb,
            new_filename: el?.new_filename,
            url: el?.url,
            extension: el?.extension
        }
    })

    const fetchChangeComment = (is_favorite) => {
        const url = `${RavshanHttps}/api/tasks/change_comment`

        const reply_to_params = reply_to ? { reply_to: reply_to?.id } : {}

        const body = JSON.stringify({
            text: comment,
            event_id,
            id,
            files: filesData,
            // reply_to: 0,
            is_favorite: is_favorite ? is_favorite : false,
            ...reply_to_params
        })


        fetch(url, { body, method: 'PUT', headers: headers })
            .then(res => {
                if (res.ok) {
                    updateComments()
                    //  fetchComments()
                    return res.json()
                } else {
                    throw new Error('bad attendees response')
                }
            })
            .catch((e) => console.error(e))
    }

    const btns = [
        {
            btn: is_favourite ? 'Удалить из избранного' : 'В избранное', func: (e) => {
                if (fetchFavorite || fetchDeleteFavorite) {
                    fetchFavorite(is_favourite ? 'del_favourite' : 'add_favourite', id, messageData, early_message_id)
                } else {
                    fetchChangeComment(!is_favourite)
                }
            }
        },
        ...((client_id == author_pinned) && is_pinned) ?
            [{
                btn: 'Открепить',
                func: (e) => {
                    fetchPinComment(is_pinned ? 'del_pinned' : 'add_pinned', id, messageData, early_message_id)
                }
            }]
            :
            [],
        ...(!is_pinned) ?
            [{
                btn: 'Закрепить',
                func: (e) => {
                    fetchPinComment(is_pinned ? 'del_pinned' : 'add_pinned', id, messageData, early_message_id)
                }
            }]
            :
            [],
        ...(isAuthor ?
            [{
                btn: 'Редактировать', func: (e) => {
                    if (!edit) {
                        setEdit(true)
                    } else {
                        fetchChangeComment()
                        setEdit(false)
                    }
                }
            },
            {
                btn: 'Удалить', func: (e) => {
                    if (fetchDelete) {
                        fetchDelete(id, early_message_id, props?.messageData)
                    }
                }
            }] : []
        )
    ];

    const [comment, setComment] = useState(text ? text : '')
    const [edit, setEdit] = useState(false)
    const [showImg, setShowImg] = useState('')

    const [filesData, setFilesData] = useState(curr_files)
    const [files1, setFiles1] = useState([])
    const [inViewElement, setInViewElement] = useState(false)

    // Добавляем ref для отслеживания кликов вне компонента
    const commentRef = useRef(null)

    const handleClickOutside = (event) => {
        if (edit && commentRef.current && !commentRef.current.contains(event.target)) {
            setEdit(false)
            setComment(text ? text : '')
            setFilesData(curr_files)
            if (setSaveFile) {
                setSaveFile([])
            }
        }
    }

    // Обработчик клика вне компонента
    useEffect(() => {
        // Добавляем обработчик только если режим редактирования активен
        if (edit) {
            document.addEventListener('mousedown', handleClickOutside)
        } else {
            document.removeEventListener('mousedown', handleClickOutside)
        }

        // Очистка обработчика при размонтировании
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [edit, text, curr_files])

    useEffect(() => {
        if (inViewElement && !is_read && (login != email)) {
            if (fetchChangeStatus) {
                fetchChangeStatus(id, early_message_id, messageData)
            }
        }
    }, [inViewElement]);

    return (
        <InView as="div" key={text + id} onChange={(inView) => {
            setInViewElement(true)
        }}>
            {showImg && <div className='show-img' onClick={(e) => setShowImg('')}>
                <img src={showImg} />
            </div>}

            {/* Добавляем ref к основному контейнеру */}
            <div
                ref={commentRef}
                key={text + id}
                className={isAuthor ? 'comment__wrapper_author' : 'comment__wrapper'}
            >
                {!isAuthor && <div className='comment__executor-content'>
                    <ExecutorPlaceholder name={name} id={author?.id} login={login} color={color} />
                </div>}

                <div
                    className={((login == email) || isAuthor) ? 'comment-item_author' : 'comment-item'}>
                    {reply_to && <div className='comment-item__reply-to'>
                        {reply_to?.author && <p className='comment-item__reply-to-author'>В ответ {parse(reply_to?.author)}</p>}
                        {reply_to?.text &&
                            <TextPage
                                style={{ fontSize: '12px' }}
                                text={parse(reply_to?.text)}
                            />
                        }
                    </div>}

                    {(login != email) && <div className='comment-item__header'>
                        <p className='text_name'>{name}</p>
                    </div>
                    }
                    <div className='comment-item__content'>
                        {
                            edit ?
                                <Comment
                                    {...props}
                                    {...author}
                                    isAuthor={isAuthor}
                                    email={login}
                                    commentValue={comment}
                                    reply_to={reply_to}
                                    changeCommentValue={e => setComment(e)}
                                    filesDataChange={filesData}
                                    setFilesDataChange={(e) => setFilesData(e)}
                                    setFilesChange={(e) => setFiles1(e)}
                                    isEdit={edit}
                                    hideBtn={true}
                                    setSaveFile={setSaveFile}
                                    type={'comments'}
                                    fetchAddFiles={fetchAddFiles}
                                    fetchGetFiles={fetchGetFiles}
                                    comment_id={id}
                                    setCommentPage={(e) => setCommentPage(e)}
                                    message_id={message_id}
                                    author_pinned={author_pinned}
                                />
                                :
                                <>
                                    <p className='text'>{parse(comment, {
                                        replace: (domNode) => {
                                            if (domNode.name === "img") {
                                                return <img src={domNode.attribs.src}
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        setShowImg(domNode.attribs.src)
                                                    }}
                                                />
                                            }
                                        }
                                    })} </p>



                                    {(filesData)?.map(({ created_at, file_size_kb, new_filename, url }, ind) => {
                                        return <FileItemComponent
                                            isAuthor={isAuthor}
                                            eventId={event_id}
                                            created_at={created_at}
                                            file_size_kb={file_size_kb}
                                            new_filename={new_filename}
                                            fetchDeleteFiles={fetchDeleteFiles}
                                            message_id={message_id}
                                            fetchComments={fetchComments}
                                            url={url}
                                            authorEmail={login}
                                            type={'comments'}
                                            comment_id={comment_id}
                                            isEdit={edit}
                                            filesdata={filesData}
                                            setFilesData={(e) => setFilesData(e)}
                                            messageData={messageData}
                                            early_message_id={early_message_id}
                                        />
                                    })}
                                </>
                        }
                    </div>

                    <div className='comment-item__date-panel'>
                        <p className='comment-item__date'>
                            {new Date(date).toLocaleDateString('ru-RU', { day: '2-digit', month: 'short', year: '2-digit', hour: 'numeric', minute: 'numeric' }).replace(' г.', '')}
                            {(login == email) && <img src={is_seen ? double_check : check} />}
                            {is_favourite && <img className='comment-item__star' src={star_icon} />}
                            {is_pinned && <img className='comment-item__star' src={pin_icon} />}
                        </p>


                        {!disabled && edit && <div className='comment-item__btn-group'>
                            {edit &&
                                <>
                                    <button className='comment-item__btn-save'
                                        onClick={e => {
                                            if (!edit) {
                                                setEdit(true)
                                            } else {
                                                if (fetchChange) {
                                                    fetchChange(id, comment, curr_files, early_message_id, props?.messageData)
                                                    setEdit(false)
                                                    setSaveFile([])
                                                } else {
                                                    fetchChangeComment()
                                                }
                                                fetchAddFiles(null, type, id)
                                                setSaveFile([])
                                                setEdit(false)
                                            }
                                        }}
                                    >
                                        Сохранить
                                    </button>

                                    <button className='comment-item__btn-save'
                                        onClick={e => {
                                            handleClickOutside()
                                        }}
                                    >
                                        Отменить
                                    </button>
                                </>
                            }
                        </div>}
                    </div>



                </div>

                {!hideTools &&
                    <div className='comment-item__group-btn'>
                        {!hideToolsPanel && <ButtonActionDrop
                            size='s'
                            btns={btns}
                            id={id}
                        />}

                        <button
                            className='comment-item__btn-answer'
                            onClick={(e) => {
                                let curr = ({ ...props, id: id })
                                if (curr?.messageData) {
                                    curr = ({ 
                                        ...props, 
                                        id: id, 
                                        ...props?.messageData
                                     })
                                }
                                setCurrentMessageAnswer(curr)
                            }} >
                            <img src={answer} />
                        </button>
                    </div>}
            </div>
        </InView>

    )
}

export { CommentItem }